module.exports = __webpack_public_path__ + "img/ogp_aldrive_big.f026f7bd.jpg";